import React, {SyntheticEvent, useMemo, useState} from "react";
import {AuthInput} from "../../../views/auth/Enter/Enter";
import {Errors as ValidationErrors} from "../../../utils/";
import {Button, InputErrors, InputPassword, PrimaryButton} from "../../common";
import {useEffectOnUpdate, useErrorCallback} from "../../../hooks";
import {createRegistrationManager} from "../../../di";
import {RegisteredUser, Role, Phone} from "../../../api-client";
import {PrimaryButtonColor} from "../../common/buttons/decorators/PrimaryButton/PrimaryButton";
import {useSearchParams} from "react-router-dom";


type Props = {
    input: AuthInput;
    onRegister: () => void;
    role: Role;
}

type PasswordErrors = {
    password?: ValidationErrors;
    confirmPassword?: ValidationErrors;
}

type RegistrationInput = {
  phone: Phone
  password: string
  role: Role,
  referrerCode?: string
}

const CreatePassword = ({input, onRegister, role}: Props) => {
  const handleError = useErrorCallback();
  const [errors, setErrors] = useState<PasswordErrors>({});
  const [confirmPassword, setConfirmPassword] = useState("");
  const [searchParams] = useSearchParams({});
  const referrerCode = searchParams.get('r');
  const regInput = useMemo((): RegistrationInput => {
    const userInput: RegistrationInput = {phone: input.phone, password: input.password, role};
    if (referrerCode) {
      return {...input, role, referrerCode};
    }
    return userInput;
  }, [input]);

  const validateForm = () => {
    const errors: PasswordErrors = {};
    if (!input.password) {
      errors.password = ["Пароль обязателен для ввода"];
    }
    if (input.password !== confirmPassword) {
      errors.confirmPassword = ["Пароли не совпадают"];
    }
    setErrors(errors);
    return Object.keys(errors).length === 0;
  };

  useEffectOnUpdate(() => {
    validateForm();
  }, [input.password, confirmPassword]);

  const handleSubmit = async (event: SyntheticEvent) => {
    event.preventDefault();
    if (validateForm()) {
      const manager = createRegistrationManager();
      try {
        const user: RegisteredUser = await manager.registerUser(regInput);
        if (user) {
          onRegister();
        }
      } catch (error: any) {
        await handleError(error);
      }
    }
  };
  return (
    <div>
      <div>
        Придумайте свой пароль
      </div>
      <form className="form" onSubmit={handleSubmit}>
        <div className="form__group">
          <InputPassword
            password={input.password}
            onInput={input.setPassword}
            title="Пароль"
            id="password"
          />
          { errors.password && <InputErrors errors={errors.password} /> }
        </div>
        <div className="form__group">
          <InputPassword
            password={confirmPassword}
            onInput={setConfirmPassword}
            title="Повторите пароль"
            id="password-confirm"
          />
          { errors.confirmPassword && <InputErrors errors={errors.confirmPassword} /> }
        </div>
        <div className="form__group">
          <PrimaryButton expanded={true} large={true} color={PrimaryButtonColor.GREEN}>
            <Button type="submit">
              Отправить
            </Button>
          </PrimaryButton>
        </div>
      </form>
    </div>
  );
};

export default CreatePassword;